import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FiX } from 'react-icons/fi'
import { useCreateUpload } from '../hooks/useCreateUpload'
import { clearCreateUpload } from '../utils/createUpload'
import '../styles/createUpload.css'

const CreateUploadBar = () => {
  const job = useCreateUpload()
  const navigate = useNavigate()
  if (!job) return null

  const busy = job.status === 'uploading' || job.status === 'publishing'
  const label = job.status === 'error'
    ? (job.error || 'Upload failed')
    : job.status === 'done'
      ? 'Uploaded'
      : job.status === 'publishing'
        ? 'Finishing…'
        : `Uploading ${job.progress || 0}%`

  return (
    <div
      className={`createUploadBar createUploadBar--${job.status}`}
      role="status"
      onClick={() => navigate('/profile')}
    >
      {job.previewUrl ? <img src={job.previewUrl} alt="" /> : <span className="createUploadBarThumb" />}
      <div className="createUploadBarBody">
        <strong>{job.title || 'New post'}</strong>
        <small>{label}</small>
        <span className="createUploadTrack" aria-hidden="true">
          <span style={{ width: `${Math.max(job.status === 'error' ? 100 : 4, job.progress || 0)}%` }} />
        </span>
      </div>
      {!busy ? (
        <button
          type="button"
          aria-label="Close"
          onClick={event => {
            event.stopPropagation()
            clearCreateUpload()
          }}
        >
          <FiX />
        </button>
      ) : null}
    </div>
  )
}

export default CreateUploadBar
